import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sales: null,
  topProducts: [],
  topCategories: [],
  topCustomers: [],
  transactions: [],
  productHistory: []
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSales: (state, action) => {
      const salesData = action.payload || {};
      const normalizedData = {};      
      Object.keys(salesData).forEach(key => {
        normalizedData[key] = salesData[key] === null ? 0 : Number(salesData[key]);
      });

      state.sales = normalizedData;
    },
    setTopProducts: (state, action) => {
      state.topProducts = action.payload;
    },
    setTopCategories: (state, action) => {
      state.topCategories = action.payload;
    },
    setTopCustomers: (state, action) => {
      state.topCustomers = action.payload;
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    setProductHistory: (state, action) => {
      state.productHistory = action.payload;
    },
  },
});

export const { 
  setSales, 
  setTopProducts, 
  setTopCategories, 
  setTopCustomers, 
  setTransactions, 
  setProductHistory 
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
